import SendButton from 'gcs-common/components/SendButton/SendButton';
import MarkReadButton from 'gcs-common/components/feature-mark-read/mark-read-button';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import {
  getChannelInputHasSendable,
  getChannelInputIsSendingDisabled,
} from 'gcs-common/slices/messageInput/messageInputSelector';
import { useSelector } from 'react-redux';

type Props = {
  onSend: () => void;
  showMarkLabel?: boolean;
  className?: string;
};

function SendOrMarkReadButton({ onSend, showMarkLabel = true, className }: Props) {
  const selectedChannelId = useSelector(getSelectedChannelId);
  const hasSendable = useSelector(getChannelInputHasSendable(selectedChannelId));
  const disabled = useSelector(getChannelInputIsSendingDisabled(selectedChannelId));

  const handleSend = () => {
    if (!disabled) onSend();
  };

  if (hasSendable) {
    return <SendButton className={className} disabled={disabled} onClick={handleSend} />;
  }

  return (
    <div className={className}>
      <MarkReadButton showMarkLabel={showMarkLabel} />
    </div>
  );
}

export default SendOrMarkReadButton;
